import { Map } from 'immutable';
import {
    GET_COUNTRIES,
    GET_STATES,
    GET_PREF_CONTACT_METHOD,
    GET_DEPARTMENT,
    GET_POSITION,
    GET_RANK,
    GET_UNIT_LOCATION,
    GET_TITLE_LIST,
    GET_UNIT
} from '../actions/contactDetails';


const initialState = Map({
    countries:[],
    states: {},
    prefContactMethod: {},
    department: '',
    position: '',
    rank: '',
    unitLocation:{},
    titleList:[],
    unit:{}
});

const actionsMap = {
  [GET_COUNTRIES]: (state, action) => {
    return state.set('countries', action.countries);
  },
  [GET_STATES]: (state, action) => {
    return state.set('states', action.states);
  },
  [GET_TITLE_LIST]: (state, action) => {
    return state.set('titleList', action.states);
  },
  [GET_PREF_CONTACT_METHOD]:(state, action) => {
    return state.set('prefContactMethod', action.states);
  },
  [GET_DEPARTMENT]:(state, action) => {
    return state.set('department', action.states);
  },
  [GET_POSITION]:(state, action) => {
    return state.set('position', action.states);
  },
  [GET_RANK]:(state, action) => {
    return state.set('rank', action.states);
  },
  [GET_UNIT_LOCATION]:(state, action) => {
    return state.set('unitLocation', action.data);
  },
  [GET_UNIT]:(state, action) => {
    return state.set('unit', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}